import type {
  EquipmentAvailabilityInput,
  EquipmentAvailabilityOutput,
  MeasurementInput,
  MeasurementListOutput,
} from "@repo/contract/training";

/**
 * The optimistic cache edits that are more than a spread, kept apart from the
 * hooks (which reach `src/native` through `useApi`) so Node tests import them.
 */

/** `place` is applied only when the body carries the key (absent keeps). */
export function applyEquipment(
  cached: EquipmentAvailabilityOutput,
  input: EquipmentAvailabilityInput
): EquipmentAvailabilityOutput {
  return {
    ...cached,
    available: input.available,
    ...("place" in input ? { place: input.place ?? null } : {}),
  };
}

/**
 * The series' headline point becomes the new one at once. `measuredAt` is
 * this device's clock only until the server answers with its own.
 */
export function applyMeasurement(
  cached: MeasurementListOutput,
  input: MeasurementInput
): MeasurementListOutput {
  if (cached.kind !== input.kind) {
    return cached;
  }
  return {
    ...cached,
    latest: {
      actorPath: "direct",
      kind: input.kind,
      measuredAt: new Date().toISOString(),
      measurementId: `pending:${input.idempotencyKey ?? ""}`,
      unit: input.unit,
      value: input.value,
    },
  };
}
